import script from "./EmptyBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyBlock.vue?vue&type=script&setup=true&lang=js"

import "./EmptyBlock.vue?vue&type=style&index=0&id=edb7e112&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edb7e112"]])

export default __exports__